import { combineReducers } from "redux";

import authReducer from "./auth";
import loadingReducer from "./loading";
import servicesReducer from "./services";
import orderReducer from "./orders";
import employeesReducer from "./employees";

const reducers = combineReducers({
  authReducer,
  loadingReducer,
  servicesReducer,
  orderReducer,
  employeesReducer,
});

export type ReducerType = typeof reducers;

export default reducers;
